const mod = require('string-template')

module.exports = mod
